module.exports = __webpack_public_path__ + "img/united_bank_for_africa.badd8675.svg";